/**
 * CompetitorAnalysis 常量定义
 */

// 价格区间排序
export const PRICE_RANGE_ORDER = ['0-5', '5-10', '10-15', '15-20', '20-30', '30-50', '50+'];

// 价格区间颜色映射
export const PRICE_RANGE_COLORS: Record<string, string> = {
    '0-5': '#f5222d',
    '5-10': '#fa8c16',
    '10-15': '#fadb14',
    '15-20': '#52c41a',
    '20-30': '#1890ff',
    '30-50': '#722ed1',
    '50+': '#eb2f96',
};
